var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddFolder = function SvgAddFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#addFolder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 8.53V19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5.434a1 1 0 0 1 .7.285l2 1.959a1 1 0 0 0 .7.285H21a1 1 0 0 1 1 1Z",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 13c0-.22.18-.4.4-.4h6.4a.4.4 0 0 1 0 .8H4.8a.4.4 0 0 1-.4-.4Z",
    fill: "#1A1E2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.4c.22 0 .4.18.4.4v6.4a.4.4 0 0 1-.8 0V9.8c0-.22.18-.4.4-.4Z",
    fill: "#1A1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "addFolder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAddFolder;